export default __webpack_public_path__ + "static/media/eye.fcb40c82.svg";